export default __webpack_public_path__ + "static/media/adobe.53d645f3.png";